import { forwardRef } from "react";
import type { ReactNode } from "react";
import type { ComponentPropsWithRef } from "react";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface ModalFooterProps extends ComponentPropsWithRef<"div"> {
  children: ReactNode;
  className?: string;
}

export const ModalFooter = forwardRef<HTMLDivElement, ModalFooterProps>(
  ({ children, className = "", ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames("sticky px-8 py-6", className)}
      data-testid="modal-footer"
      {...rest}
    >
      {children}
    </div>
  ),
);

ModalFooter.displayName = "ModalFooter";
